import ComptesListView from "@/pages/super-admin/components/ComptesListView";

export default function SuperAdminUtilisateursPage() {
  return <ComptesListView type="utilisateur" />;
}